import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedIcon","ColumnsIcon","ButtonIcon","SingleImage","ImagesGrid","QuoteIcon","BadgeIcon","LandingPage"] */ "/app/src/components/v1/page-style/admin/editor-console/content/widget/widget.style.ts");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/recycle-dashboard-closure-notice/recycle-dashboard-closure-notice.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/article/blocks/columns/columns.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/article/blocks/content/content.tsx");
